import React from 'react';

/**
 * Modale de confirmation réutilisable.
 *
 * Props :
 *   open         – booléen, affiche ou masque
 *   title        – titre court
 *   message      – corps du message (texte ou JSX)
 *   confirmLabel – libellé du bouton de confirmation (défaut : "Confirmer")
 *   cancelLabel  – libellé du bouton annuler (défaut : "Annuler")
 *   variant      – "danger" | "primary" (couleur du bouton de confirmation)
 *   onConfirm    – callback appelé au clic sur Confirmer
 *   onCancel     – callback appelé au clic sur Annuler ou fond
 */
function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  variant = 'primary',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div
      className="modal"
      onClick={onCancel}
      style={{ zIndex: 1100 }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 440 }}
      >
        <div className="modal-header">
          <h2 style={{ fontSize: 18 }}>{title}</h2>
          <button className="close-btn" onClick={onCancel}>×</button>
        </div>

        <div style={{ padding: '4px 0 20px', color: 'var(--color-text-secondary)', fontSize: 14, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
          {message}
        </div>

        <div className="actions" style={{ paddingTop: 0 }}>
          <button
            className={`btn btn-${variant}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
          <button className="btn btn-secondary" onClick={onCancel}>
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
